import { forwardRef } from 'react'
import styled, { css } from 'styled-components'
import SearchIcon from '@tuhi/components/assets/icons/buttons/searchIcon.svg'
import ClearIcon from '@tuhi/components/assets/icons/buttons/clear.svg'
import {
    textColorStyles,
    textSizeStyles,
    textWeightStyles,
} from '../text/textStyles'
import { BaseButton } from '../../components'
import { contentColorStyle } from '../buttons/button'
import { media } from '../../theme/breakpoints'

type WidthType = 'medium' | 'fill'

const widthStyles = {
    medium: css`
        width: 320px;
    `,
    fill: css`
        width: 100%;
    `,
}

const Container = styled.div<{ $isActive?: boolean; $width: WidthType }>`
    display: flex;
    align-items: center;
    overflow: hidden;

    height: 36px;
    min-height: 36px;
    
    ${(p) => widthStyles[p.$width]}

    ${media.mobile} {
        height: 44px;
        min-height: 44px;
    }

    background: ${(p) => p.theme.colors.white};
    border-radius: 8px;
    border: 1px solid ${(p) => p.theme.colors.primary.default}};
`

const Input = styled.input`
    flex: 1;
    border: none;
    background: none;
    outline: none;
    padding-left: 16px;
    padding-right: 16px;
    ${textColorStyles['secondary']}

    &:focus {
        border: none;
        ${textColorStyles['primary']}
    }

    ${textSizeStyles['xSmall']}
    ${textWeightStyles['regular']}

    ${media.mobile} {
        font-size: 16px;
    }
`

const ClearButton = styled(BaseButton)`
    padding-right: 16px;
    min-width: 44px;
    min-height: 44px;

    ${(p) => contentColorStyle(p.theme.colors.primary.default)}
`

const SearchButton = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    min-width: 44px;
    background-color: ${(p) => p.theme.colors.primary.default};
    padding-left: 10px;
    padding-right: 10px;
    border: none;
    cursor: pointer;
`

interface Props {
    label?: string
    placeholder?: string
    onChange: (text: string) => void
    onSearch?: () => void
    value?: string
    width?: WidthType
}

export const InputSearch = forwardRef<HTMLInputElement, Props>((props, ref) => {
    const { placeholder, onChange, onSearch, value, width } = props

    const handleClear = () => {
        onChange('')
    }

    return (
        <Container $width={width ?? 'medium'}>
            <Input
                ref={ref}
                value={value ?? ''}
                type="text"
                placeholder={placeholder}
                onChange={(event) => {
                    onChange(event.target.value)
                }}
                onKeyDown={(e) => (e.key === 'Enter' ? onSearch?.() : '')}
            />

            {(value?.length ?? 0) > 0 && (
                <ClearButton onClick={handleClear}>
                    <ClearIcon />
                </ClearButton>
            )}

            <SearchButton onClick={onSearch}>
                <SearchIcon />
            </SearchButton>
        </Container>
    )
})
